import { Typography } from "antd";

import { formatCurrency } from "@/utils/format";

const { Text, Title } = Typography;

interface CartPriceSummaryProps {
  itemCount: number;
  total: number;
  shippingFee: number;
  finalTotal: number;
  discountAmount?: number;
  shippingLabel?: string;
  variant?: "card" | "drawer";
  voucherCode?: string;
}

export const CartPriceSummary = ({
  discountAmount = 0,
  finalTotal,
  itemCount,
  shippingFee,
  shippingLabel = "Phí vận chuyển",
  total,
  variant = "card",
  voucherCode,
}: CartPriceSummaryProps) => {
  if (variant === "drawer") {
    return (
      <div className="cart-price-summary cart-price-summary--drawer">
        <div className="cart-price-summary__row cart-price-summary__row--total">
          <Text strong>Tổng thanh toán</Text>
          <Title className="cart-price-summary__total-amount" level={3}>
            {formatCurrency(finalTotal)}
          </Title>
        </div>
      </div>
    );
  }

  return (
    <div
      className="cart-price-summary"
      style={{ width: "100%", backgroundColor: "" }}
    >
      <div className="summary-row">
        <Text>Số lượng sản phẩm</Text>
        <Text>{itemCount}</Text>
      </div>
      <div className="summary-row">
        <Text>Tạm tính</Text>
        <Text>{formatCurrency(total)}</Text>
      </div>
      <div className="summary-row">
        <Text>{shippingLabel}</Text>
        <Text>
          {shippingFee === 0 ? "Miễn phí" : formatCurrency(shippingFee)}
        </Text>
      </div>
      {discountAmount > 0 ? (
        <div className="summary-row">
          <Text>{voucherCode ? `Giảm giá · ${voucherCode}` : "Giảm giá"}</Text>
          <Text>-{formatCurrency(discountAmount)}</Text>
        </div>
      ) : null}
      <div className="cart-price-summary__row cart-price-summary__row--total">
        <Text strong>Tổng thanh toán</Text>
        <Title className="cart-price-summary__total-amount" level={4}>
          {formatCurrency(finalTotal)}
        </Title>
      </div>
    </div>
  );
};
